// Helpers for date-only values ('YYYY-MM-DD' — birthdays, due dates).
//
// `new Date('1977-12-04')` parses as UTC midnight, and a DATE column that the
// backend serializes as '1977-12-04T00:00:00.000Z' has the same problem: an
// Eastern-time browser renders either one as Dec 3. Everything here builds
// LOCAL dates from the year/month/day parts so the calendar day never shifts.

export function parseLocalDate(dateStr) {
  if (!dateStr) return null;
  const datePart = String(dateStr).split('T')[0];
  const parts = datePart.split('-').map(Number);
  if (parts.length < 3 || parts.some((n) => Number.isNaN(n))) return null;
  const d = new Date(parts[0], parts[1] - 1, parts[2]);
  return Number.isNaN(d.getTime()) ? null : d;
}

const DAY_MS = 86400000;

function startOfDay(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

// Whole days from `now` (local midnight) to the given date-only string.
export function daysUntil(dateStr, now = new Date()) {
  const d = parseLocalDate(dateStr);
  if (!d) return null;
  return Math.round((startOfDay(d) - startOfDay(now)) / DAY_MS);
}

// Friendly label for an upcoming date: Today / Tomorrow / Saturday / Mon, Oct 12.
export function formatUpcoming(dateStr, now = new Date()) {
  const d = parseLocalDate(dateStr);
  if (!d) return '';
  const days = daysUntil(dateStr, now);
  if (days === 0) return 'Today';
  if (days === 1) return 'Tomorrow';
  if (days > 1 && days < 7) return d.toLocaleDateString('en-US', { weekday: 'long' });
  return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
}

// 'Dec 4, 1977' from a date-only string.
export function formatLongDate(dateStr) {
  const d = parseLocalDate(dateStr);
  return d ? d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '';
}
